import { pageNo, catEndPoints,catTreeEndPoints } from "../../config";
import { getQueryStringFrmObject,getQueryString, redirectPage,postApi,getApi} from "@iso/lib/helpers/utility";
import { getCookie } from "@iso/lib/helpers/session";

class catApi {
  /******************************** Start of user read list ****************************/
  read = async (editInfo) => {
    let itemUrl;
    itemUrl = catEndPoints.read + "?pageNo=" + editInfo.page + "&per_page=" + pageNo;

    if (editInfo.info) {
      var queryString = getQueryStringFrmObject(editInfo);
      itemUrl = itemUrl + "&" + queryString;
    }
    if (editInfo.flag === "categoryTree") {
      itemUrl = catEndPoints.read;
    }
    return await fetch(itemUrl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: getCookie("id_token") ? getCookie("id_token") : "",
      },
    })
      .then(function (response) {
        //   alert(response.status);
        if (response.status >= 400) {
          if (response.status === 404) {
            redirectPage("/404");
          } else {
            redirectPage("/500");
          }
        }
        return response.json();
      })
      .then((res) => {
        return res;
      })
      .catch((error) => ({ error }));
  };
  /******************************** End of user read list ****************************/

  /********************************Start findById**********************************/
  findById = async (fetchById) => {
    console.log("fetch type id ", fetchById);
    const fetchListUrl = catEndPoints.findById + "/" + fetchById;
    return await fetch(fetchListUrl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: getCookie("id_token") ? getCookie("id_token") : "",
      },
    })
      //.then(response => response.json())
      .then(function (response) {
        //   alert(response.status);
        if (response.status >= 400) {
          if (response.status === 404) {
            redirectPage("/404");
          } else {
            redirectPage("/500");
          }
        }
        return response.json();
      })
      .then((res) => {
        return res;
      })
      .catch((error) => ({ error }));
  };

  /********************************Start update attribute**********************************/
  updateAttByMgc = async (payload) => {
    return await fetch(catEndPoints.updateAttByMgc, {
      method: "put",
      headers: { Accept: "application/json", "Content-Type": "application/json", authorization: getCookie("id_token") ? getCookie("id_token") : "" },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        return res;
      })
      .catch((error) => ({ error }));
  };

  /*******************************End findById*************************************/

    /********************************Start update attribute**********************************/
    updateNutAttById = async (payload) => {
      console.log('Amit-----',catEndPoints.updateNutAttByID);
      return await fetch(catEndPoints.updateNutAttByID, {
        method: "put",
        headers: { Accept: "application/json", "Content-Type": "application/json", authorization: getCookie("id_token") ? getCookie("id_token") : "" },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((res) => {
          console.log(res);
          return res;
        })
        .catch((error) => ({ error }));
    };
  
    /*******************************End findById*************************************/

    leafAdd = async (pojo) => {
      if (pojo) {
        console.log("pojopojo", pojo);
        var result = await postApi(catTreeEndPoints.leafAdd, pojo);
        return result;
      }
    };

    /**
     * Soft Delete Leaf Category
     */
    leafDelete = async (pojo) => {
      if (pojo) {
        var result = await postApi(catTreeEndPoints.leafDel, pojo);
        return result;
      }
    };

  /**
     * Diabtese Color values Get
     */
    diabteseColorValGet = async (params) => {
      if (params) {
        let url = catTreeEndPoints.diabteseList
        if(params){
          var queryString = getQueryStringFrmObject(params);
          url = url + '?'+queryString
        }
        var result = await getApi(url);
        return result;
      }
    };
     TLLValGet = async (params) => {
      if (params) {
        let url = catTreeEndPoints.TLLList
        if(params){
          var queryString = getQueryStringFrmObject(params);
          url = url + '?'+queryString
        }
        var result = await getApi(url);
        return result;
      }
    };
}

export default new catApi();
